// extracted by mini-css-extract-plugin
export default {"button":"Button_button__o6Qr5","loading":"Button_loading__CZCYh","spin":"Button_spin__ZKBqe","grow":"Button_grow__TXjoQ"};